"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const components_1 = require("apps/influencers/shared/components");
const components_2 = require("apps/influencers/CampaignLinkPage/components");
const controllers_1 = require("apps/influencers/shared/controllers");
const controllers_2 = require("apps/influencers/CampaignLinkPage/controllers");
class LayoutUI extends React.Component {
    render() {
        const { campaign, brand, currentUser, partnerId, isValid } = this.props;
        if (currentUser && currentUser.role === 'influencer')
            return null;
        if (!isValid)
            return React.createElement(components_2.InvalidLinkPage, null);
        return (React.createElement("div", null,
            partnerId && React.createElement(controllers_1.PartnerMessageDialog, { partnerId: partnerId }),
            React.createElement(components_1.ParticipationLayout, { campaign: campaign, header: React.createElement(controllers_1.PublicCampaignHeader, { campaign: campaign }), right: React.createElement(components_2.ResponsiveDialog, null,
                    React.createElement(controllers_2.InfluencerLogin, { brand: brand })) })));
    }
}
exports.default = LayoutUI;
